import { RefObject, useEffect, useState } from 'react'

function useHover<T extends HTMLElement = HTMLElement> (
  elementRef: RefObject<T>
): boolean {
  const [value, setValue] = useState<boolean>(false)

  const handleMouseEnter = (): void => setValue(true)
  const handleMouseLeave = (): void => setValue(false)

  useEffect(() => {
    const node = elementRef?.current

    if (node) {
      node.addEventListener('mouseenter', handleMouseEnter)
      node.addEventListener('mouseleave', handleMouseLeave)

      return () => {
        node.removeEventListener('mouseenter', handleMouseEnter)
        node.removeEventListener('mouseleave', handleMouseLeave)
      }
    }
  }, [elementRef])

  return value
}

export default useHover
